import "./css/Spinner.css";

export default function Spinner({ ...props }) {
  return <div className="spinner"></div>;
}
